import systemBuildVariant, { BUILDS } from '../../../../config/buildVariant';

// eslint-disable-next-line no-unused-vars
const isLiveBetter = () => systemBuildVariant === BUILDS.mylivebetter;

export function serviceIsEnabledForPlatform() {
    return false; // If you want to re-enable Survicate later, remove the false and use: !isLiveBetter(). That will enable it for Sprout, but not LiveBetter.
}